import React from 'react';

import { AuthProvider } from './auth';
import { ConfigProvider } from './config';
import { CustomThemeProvider } from '../contexts/themeContext';
import { StyledProvider } from '../contexts/styledComponetsContext';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { AlertProvider } from '../contexts/Alert.context';
import { Alert } from '../components/Alert/Alert';
import { NotificationOrderProvider } from './notificationOrder';
import { CompanyProvider } from './useCompany';
import { WarningProvider } from './useWarnings';

const AppProvider = ({ children }) => (
  <CustomThemeProvider>
    <StyledProvider>
      <DndProvider backend={HTML5Backend}>
        <AlertProvider>
          <AuthProvider>
            <CompanyProvider>
              <ConfigProvider>
                <WarningProvider>
                  <NotificationOrderProvider>{children}</NotificationOrderProvider>
                </WarningProvider>
              </ConfigProvider>
            </CompanyProvider>
            <Alert />
          </AuthProvider>
        </AlertProvider>
      </DndProvider>
    </StyledProvider>
  </CustomThemeProvider>
);

export default AppProvider;
